import { Router } from '@angular/router';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
declare const $: any;

@Component({
  selector: 'app-level1menu',
  templateUrl: './level1menu.component.html',
  styleUrls: ['./level1menu.component.css']
})
export class Level1menuComponent implements OnInit {

  @Output() change = new EventEmitter();
  menuList: any;
  selectedItem: any;
  pageList: any;
  panelOpenState = false;
  name: any;

  constructor(private router: Router) { }

  ngOnInit() {
    this.menuList = localStorage.getItem('menuList');
    this.menuList = JSON.parse(this.menuList);
    let selectedMenuId = localStorage.getItem('selectedMenu');
    if (selectedMenuId != null && selectedMenuId != '' && typeof (selectedMenuId) != undefined)
      this.selectedItem = selectedMenuId;
    else {
      if (this.menuList.length != 0)
        this.selectedItem = this.menuList[0].MenuId;
      for (let i = 0; i < this.menuList.length; i++) {
        this.pageList = this.menuList[i].PagesList;
        return
      }
      console.log(this.selectedItem);
    }
  }

  Logout() {
    localStorage.clear();
    this.change.emit(true);
    this.router.navigate(['/login']);
  }

  ngAfterViewInit() {
    this._activateMenuDropdown();
    $('#menu1').metisMenu();
  }

  _activateMenuDropdown() {
    this.activateMenuItems();
  }

  activateMenuItems() {
    const links = document.getElementsByClassName('side-nav-link');
    let menuItemEl = null;
    for (let i = 0; i < links.length; i++) {
      if (window.location.hash === links[i]['hash']) {
        menuItemEl = links[i];
        break;
      }
    }
    if (menuItemEl) {
      menuItemEl.classList.add('mm-active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');

        const parent2El = parentEl.parentElement;
        if (parent2El) {
          parent2El.classList.add('mm-show');
        }
        const parent3El = parent2El.parentElement;
        if (parent3El) {
          parent3El.classList.add('mm-active');
        }
      }
    }
  };

}



// WEBPACK FOOTER //
// ./src/app/common/level1menu/level1menu.component.ts